import _ from 'lodash';
import dayjs from 'dayjs';

const textValidate = values => {
  if (values && values.value && (values.value.length > 500 || /^[\s\n\r]+$/.test(values.value))) {
    return 'Некорректное значение';
  }
};

const defaultValidate = () => null;

const numberRangeValidate = values => {
  const errors = {};
  let isValid = true;
  if (_.get(values, 'value.from') && _.get(values, 'value.to') && +values.value.from > +values.value.to) {
    isValid = false;
    errors.to = 'Некорректное значение';
  }

  return isValid ? null : errors;
};

const dateRangeValidate = values => {
  const errors = {};
  if (
    _.get(values, 'value.from') &&
    _.get(values, 'value.to') &&
    dayjs(values.value.from).isSame(dayjs(values.value.to))
  ) {
    errors.all = 'Некорректное значение';
    return errors;
  }
};

export default {
  1: textValidate,
  2: defaultValidate,
  3: defaultValidate,
  4: defaultValidate,
  5: defaultValidate,
  6: dateRangeValidate,
  7: numberRangeValidate,
  8: defaultValidate,
  9: defaultValidate,
};
